import { memo } from "react";
import { CartItemModifierModel, StoreModifierModel } from "../../models";
import { formatCurrency } from "../../utilities";

type Props = {
  groupIndex: number;
  modifier: StoreModifierModel;
  cartModifier: CartItemModifierModel;
  inflationContext: {
    typeId: number | string;
    hasAdInflation: boolean;
    productPrice: number;
    productBasePrice: number;
  };
};

const ModifierPriceComponent: React.FC<Props> = ({
  groupIndex,
  modifier,
  cartModifier,
  inflationContext,
}) => {
  const { typeId, hasAdInflation, productPrice, productBasePrice } =
    inflationContext;
  const modInflation = Array.isArray(modifier.convenience)
    ? 0
    : Number(modifier.convenience?.[String(typeId)] || 0);
  const adInflation = Array.isArray(modifier.convenience)
    ? 0
    : hasAdInflation
      ? Number(modifier.convenience?.["adsp"] || 0)
      : 0;

  const price =
    (cartModifier?.prices ?? []).reduce((acc, a) => {
      return acc + Number(a.price);
    }, 0) || modifier.m_price;

  const modifierBasePrice = Number(price) + modInflation + adInflation;
  const modifierPrice =
    modifierBasePrice +
    (groupIndex === 0 && productPrice === 0 ? productBasePrice : 0);

  return <>{formatCurrency(modifierPrice)}</>;
};

const ModifierPrice = memo(ModifierPriceComponent);

export default ModifierPrice;
